module.exports = __webpack_public_path__ + "img/user-8.4a692860.png";